import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import AuthShell, { Field, Input } from "../components/AuthShell";

export default function CustomerSignup() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const nav = useNavigate();
  const upd = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await signup(form);
      toast.success(`Welcome to Ayame, ${u.name}`);
      nav("/account");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create Your Account" subtitle="Track bookings · AI recommendations">
      <form onSubmit={submit} className="space-y-4" data-testid="customer-signup-form">
        <Field label="Full Name"><Input required value={form.name} onChange={e=>upd("name",e.target.value)} data-testid="signup-name" /></Field>
        <Field label="Email"><Input type="email" required value={form.email} onChange={e=>upd("email",e.target.value)} data-testid="signup-email" /></Field>
        <Field label="Phone (WhatsApp)"><Input required value={form.phone} onChange={e=>upd("phone",e.target.value)} placeholder="+971 50 ..." data-testid="signup-phone" /></Field>
        <Field label="Password (min 6)"><Input type="password" required minLength={6} value={form.password} onChange={e=>upd("password",e.target.value)} data-testid="signup-password" /></Field>
        <button type="submit" disabled={loading}
          className="btn-gold w-full rounded-full py-3 text-sm tracking-widest uppercase disabled:opacity-60" data-testid="signup-submit">
          {loading ? "Creating..." : "Create Account"}
        </button>
        <p className="text-xs text-center text-[var(--muted)]">Have an account? <Link to="/login" className="hover:text-[var(--accent)]">Sign in</Link></p>
      </form>
    </AuthShell>
  );
}
